
import { defineComponent, ref, toRefs, watch } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import { IError } from "./interface";

export default defineComponent({
  props: {
    formData: {
      type: Object,
      default: () => ({
        username: "",
        password: "",
      }),
    },
    initialError: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["submit"],
  setup(props, { emit }) {
    const modalError = ref<boolean>(false);
    const isShowPassword = ref<boolean>(true);
    const error = ref<IError>({
      email: [],
      password: [],
    });
    const { formData, initialError } = toRefs(props);
    const rules = {
      username: {
        required: helpers.withMessage("Username harus diisi", required),
      },
      password: {
        required: helpers.withMessage("Kata sandi harus diisi", required),
      },
    };
    const v$ = useVuelidate(rules, formData);

    const submitForm = (): void => {
      v$.value.$validate();
      const isInvalid = v$.value.$invalid;
      if (!isInvalid) emit("submit", formData.value);
    };

    const handleEnterKey = (event: KeyboardEvent): void => {
      // Allow Enter key to submit the form from any input field
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        submitForm();
      }
    };

    const assignError = (paramsError: IError) => {
      if (Object.keys(paramsError).length > 0) {
        error.value = {
          ...paramsError,
        };
      }
    };

    const togglePassword = () => {
      isShowPassword.value = !isShowPassword.value;
    };

    watch(initialError, (value) => {
      assignError(value);
    });

    return {
      v$,
      modalError,
      isShowPassword,
      error,
      submitForm,
      handleEnterKey,
      togglePassword,
    };
  },
});
